import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { StepperState } from './claim-timeline-stepper';

interface IStageProps {
    type: StepperState;
}

export const Circle = styled.circle<IStageProps>`
    fill: ${(props: IStageProps): string => {
        switch (props.type) {
            case 'complete':
                return Variables.Colors.b300;
            case 'current':
                return Variables.Colors.b300;
            case 'pending':
            case 'skipped':
            default:
                return Variables.Colors.n15;
        }
    }};
`;
export const Dot = styled.circle`
    fill: ${Variables.Colors.ghostWhite};
`;

export const LineBg = styled.line`
    stroke: ${Variables.Colors.n15};
    stroke-width: 4px;
`;
export const LineFg = styled.line`
    stroke: ${Variables.Colors.b300};
    stroke-width: 4px;
`;
export const Icon = styled.path`
    fill: ${Variables.Colors.ghostWhite};
`;

export const Font = (props: IStageProps): string => {
    switch (props.type) {
        case 'complete':
            return Variables.Colors.n50;
        case 'current':
            return Variables.Colors.n100;
        case 'pending':
        case 'skipped':
        default:
            return Variables.Colors.n15;
    }
};

export const Step = styled.text<IStageProps>`
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
    ${Font}
`;
export const Label = styled.text<IStageProps>`
    font-size: 18px;
    ${Font}
`;
